export const API_URL = "https://bakinzone-server.netlify.app/.netlify/functions";
